import React from 'react';
import PropTypes from 'prop-types';

import {Helmet} from 'react-helmet';

export default dataFn => function asJSONLDSnippet(props) {
  const data = dataFn(props);

  if (!data) {
    return false;
  }

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(data)}</script>
    </Helmet>
  );
}



// WEBPACK FOOTER //
// ./components/JSON-LD/asJSONLDSnippet.js